export default "__VITE_ASSET__Ds7Ooszx__"